<!--
 * @Author: shiklexin
 * @Date: 2019-08-05 17:23:10
 * @LastEditors: DouDou
 * @LastEditTime: 2020-09-27 17:42:53
 * @Description:
 -->
<template>
  <div class="details">
      <div class="details-header">
        <div class="details-money">
          <h3 class="details-cash"><output>{{bannerinfo.dataNum || 0}}</output> {{bannerinfo.dataUnit || '元'}}</h3>
          <p class="details-tip">累计提现</p>
          <div class="details-pay" v-html="pay"></div>
        </div>
      </div>
      <!-- 明细列表 -->
      <div class="details-list" v-if="datalist.length > 0">
        <ul class="details-item-box">
          <li class="details-item" v-for="(itemCon, idx) in datalist" :key="idx">
            <p class="details-item-cash">成功提现{{formatData(itemCon.amount, '提现金额：')}}！{{formatData(itemCon.remark, '恭喜你，提现成功！')}}</p>
            <p class="details-item-time">{{formatData(itemCon.createTime, '提现时间：')}}</p>
          </li>
          <li class="details-item">
            <p class="details-more" v-if="!noMoreData" @click="loadMore">点击加载更多</p>
            <p class="details-more" v-if="noMoreData">没有更多了</p>
          </li>
        </ul>
      </div>
      <div v-if="!datalist.length" class="datails-empty">
        <div class="details-empty-text">- 暂无记录 -</div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'withDrawRecord',
  data () {
    return {
      pageSize: 8, // 分页每页条数
      datalist: [], // 列表循环开始
      pageNum: null, // 当前第几页
      loading: false,
      noMoreData: false, // 列表循环结束
      shownextpage: false,
      bannerinfo: { text: '您在网校总消费金额为0元' }
    }
  },
  created () {
    this.$toast.loading({
      message: '加载中...',
      duration: 0
    })
    this.showinfoData()
  },
  computed: {
    pay () {
      return this.bannerinfo.text.replace(/(\d+元)$/g, "<output style='color: #f83f53'>  $1</output>")
    }
  },
  methods: {
    formatData (text, replace) {
      return text.replace(replace, '')
    },
    // 获取展示信息
    showinfoData () {
      this.$api.getSuccessList().then(res => {
        this.$toast.clear()
        if (res.code === 0) {
          const { acusercash } = res.data
          this.datalist = acusercash.cash.data
          this.bannerinfo = acusercash.banner || { text: '您在网校总消费金额为0元' }
          const { page } = acusercash.cash
          if (page) {
            this.pageNum = page.pageNum
            this.pageSize = page.pageSize
            this.noMoreData = false
          } else {
            this.noMoreData = true
          }
        }
      })
    },
    loadMore () {
      if (this.pageNum === null) return
      this.$api.getSuccessListPageinfo(this.pageNum, this.pageSize).then(res => {
        // eslint-disable-next-line
        this.datalist.push.apply(this.datalist, res.data.data)
        if (res.data.page) {
          this.pageNum = res.data.page.pageNum
          this.pageSize = res.data.page.pageSize
        } else {
          this.noMoreData = true
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.details {
  height: 100vh;

  .details-header {
    width: 100%;
    min-height: 136px;
    padding: 22px 0 25px 0;
    border-top: 2px solid #f3f3f3;
    border-bottom: 5px solid #f3f3f3;

    .details-money {
      font-size: 12px;
      font-weight: 400;

      .details-cash {
        output {
          font-size: 24px;
          font-weight: bolder;
          color: #f83f53;
        }
      }

      .details-tip {
        margin: 15px auto 16px;
        font-size: 12px;
        font-weight: 300;
      }

      .details-pay {
        color: #1e1e1e;
      }
    }
  }

  .details-list {
    padding: 0 12px 20px;
    overflow: scroll;

    .details-item-box {
      .details-item {
        padding: 10px 15px;
        text-align: left;
        background-color: #fff;
        border-bottom: 1px solid #ebebeb;

        &:last-child {
          border-bottom: none;
        }

        .details-item-cash {
          font-size: 14px;
          font-weight: 400;
          line-height: 26px;
          color: #1e1e13;
        }

        .details-item-time {
          padding: 3px 0;
          font-size: 12px;
          font-weight: 300;
          color: #666;
        }

        .details-more {
          font-size: 12px;
          font-weight: normal;
          text-align: center;
          color: #858c96;
        }
      }
    }
  }

  .datails-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;

    .details-empty-text {
      font-size: 12px;
      font-weight: 400;
      color: #9b9b9b;
    }
  }
}
</style>
